<template>
  <b-container fluid class="px-0 position-relative">
    <b-carousel
      id="carousel-1"
      :interval="4000"
      fade
      background="#ababab"
      img-width="100vw"
      img-height="63%"
    >
      <b-carousel-slide :img-src="bgLanding" v-if="!isDonationPage && !isPremiumPage">
        <div class="d-flex flex-column w-57 " style="padding-bottom:8%">
          <span class="slider-title text-left">Login or Register</span>
        </div>
        <div class="slider-image-topup">
          <img src="@/assets/phone-slider.png" />
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="bgDonationsSlider" v-if="isDonationPage">
        <div class="d-flex flex-column w-51 " style="padding-bottom:8%">
          <span class="slider-title text-left">Missions</span>
          <p class="text-left" style="margin-bottom: 4px;">Donate to MusicVerse to support missions</p>
          <p class="text-left">MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors</p>
        </div>

      </b-carousel-slide>
      <b-carousel-slide :img-src="bgSubscribeSlider" v-if="isPremiumPage">
        <div class="d-flex flex-column w-57 " style="padding-bottom:8%">
          <span class="slider-title text-left">Go Premium for as low as $1!</span>
          <p class="text-left">Enjoy listening to songs in full, listen to songs offline, and share to missions. Cancel anytime!</p>
          <div class="d-flex">
            <a @click="gotToRoute('subscribe')" class="learn-more " align="center" style="width: 210px;cursor:pointer">Go Premium</a>
          </div>
        </div>
        <div class="slider-image-subscribe">
          <img src="@/assets/person-subscribe.png" />
        </div>
      </b-carousel-slide>
    </b-carousel>
  </b-container>
</template>

<script>
import bgLanding from '@/assets/bg-landing.png';
import bgDonationsSlider from '@/assets/bg-donations-slider.jpg';
import bgSubscribeSlider from '@/assets/bg-subscribe-slider.png';
import {mapActions} from "vuex";
const MV_URL = process.env.MUSICVERSE_URL;
const MV_URL_WP = process.env.MUSICVERSE_URL_WP;

export default {
  name: "HeaderLandingContent",
  data: () => ({
    mv_url:MV_URL,
    mv_url_wp:MV_URL_WP,
    bgLanding:bgLanding,
    bgDonationsSlider:bgDonationsSlider,
    bgSubscribeSlider:bgSubscribeSlider,
  }),
  computed:{
    currentRoute() {
      return this.$route.name;
    },
    isDonationPage(){
      return this.currentRoute === 'DonationPageAnon';
    },
    isPremiumPage(){
      return this.currentRoute === 'PremiumPage';
    },
  },
  methods:{
    ...mapActions('NotificationModule', ['setNextPage']),
    gotToRoute(route = 'home'){
      this.setNextPage(route==='home'?'Dashboard':'SubscribePage');
      this.$router.push({ name: 'Registration' });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HeaderLandingContent.vue